// extracted by mini-css-extract-plugin
module.exports = {"knowMoreLink":"AllInOneIndia_knowMoreLink__ZlSIW","allinoneIndiaContainer":"AllInOneIndia_allinoneIndiaContainer__z1C3_"};